import {
  Sanity$GridItem,
  Sanity$GridStylingOptions,
} from '@otovo/shared/types/sanityTypes';

import { stegaClean } from 'next-sanity';
import SectionWrapper from '../../SectionWrapper';
import GridCards from './GridCards';
import ImageItems from './GridImages';

type Props = {
  heading?: string;
  description?: string;
  items: Sanity$GridItem[];
  stylingOptions: Sanity$GridStylingOptions;
};

const ContentGrid = ({
  heading,
  description,
  items,
  stylingOptions,
}: Props) => {
  const colorScheme = stegaClean(stylingOptions.colorScheme);
  const itemStyle = stegaClean(stylingOptions.itemStyle);

  const sectionColor = itemStyle === 'image' ? colorScheme : 'white';
  return (
    <SectionWrapper gap="gap-0" colorScheme={sectionColor}>
      {(heading || description) && (
        <div className="col-span-full max-w-2xl space-y-4">
          {heading && (
            <h2 className="text-2xl font-semibold text-balance break-words text-heading md:text-3xl lg:mr-16 lg:text-4xl">
              {heading}
            </h2>
          )}
          {description && (
            <p className="text-subheading md:text-xl">{description}</p>
          )}
        </div>
      )}
      <div className="col-span-12 mt-10 w-full">
        {itemStyle === 'image' && (
          <ImageItems items={items} stylingOptions={stylingOptions} />
        )}

        {itemStyle === 'card' && (
          <GridCards items={items} stylingOptions={stylingOptions} />
        )}
      </div>
    </SectionWrapper>
  );
};

export default ContentGrid;
